var _rect, _rect2, _rect3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.791504,
    y: 0.791016,
    width: 38,
    height: 38,
    rx: 19,
    fill: "var(--inputBGOpacity)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.791504,
    y: 0.791016,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#74838B",
    strokeWidth: 1.58333
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.791504,
    y: 0.791016,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "var(--controlBorderColor)",
    strokeWidth: 1.58333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8684 23.5602V27.4833C25.8684 27.8301 25.7307 28.1628 25.4854 28.408C25.2402 28.6532 24.9076 28.791 24.5607 28.791H14.0992C13.7524 28.791 13.4198 28.6532 13.1745 28.408C12.9293 28.1628 12.7915 27.8301 12.7915 27.4833V23.5602M25.8684 23.5602H24.5607H14.0992H12.7915M25.8684 23.5602V18.3295M12.7915 23.5602V18.3295M25.8684 18.3295V13.0987C25.8684 12.7519 25.7307 12.4193 25.4854 12.174C25.2402 11.9288 24.9076 11.791 24.5607 11.791H14.0992C13.7524 11.791 13.4198 11.9288 13.1745 12.174C12.9293 12.4193 12.7915 12.7519 12.7915 13.0987V18.3295M25.8684 18.3295H24.5607H14.0992H12.7915",
    stroke: "var(--defaultIconColor)",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.061 14.7334C16.2414 14.7336 16.3872 14.8801 16.3872 15.0605C16.387 15.2407 16.2412 15.3865 16.061 15.3867C15.8806 15.3867 15.7341 15.2409 15.7339 15.0605C15.7339 14.88 15.8805 14.7334 16.061 14.7334Z",
    fill: "var(--defaultIconColor)",
    stroke: "var(--defaultIconColor)",
    strokeWidth: 0.653846
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.061 19.9639C16.2414 19.9641 16.3872 20.1106 16.3872 20.291C16.387 20.4712 16.2412 20.6169 16.061 20.6172C15.8806 20.6172 15.7341 20.4714 15.7339 20.291C15.7339 20.1105 15.8805 19.9639 16.061 19.9639Z",
    fill: "var(--defaultIconColor)",
    stroke: "var(--defaultIconColor)",
    strokeWidth: 0.653846
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.061 25.1943C16.2414 25.1946 16.3872 25.3411 16.3872 25.5215C16.387 25.7017 16.2412 25.8474 16.061 25.8477C15.8806 25.8477 15.7341 25.7018 15.7339 25.5215C15.7339 25.3409 15.8805 25.1943 16.061 25.1943Z",
    fill: "var(--defaultIconColor)",
    stroke: "var(--defaultIconColor)",
    strokeWidth: 0.653846
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarDataIcon);
export default __webpack_public_path__ + "static/media/solar-data-icon.230926bcc30b1754128ba1af29d9954a.svg";
export { ForwardRef as ReactComponent };